// extracted by mini-css-extract-plugin
export default {"searchContainer":"booking_config___searchContainer___c2bb57f4","rootInput":"booking_config___rootInput___ccb87418"};